export default {"src":"/_next/static/media/slack.2e289ae6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};